export default __webpack_public_path__ + "static/media/latest-technologies.55d4d8de.png";